import React from 'react';
import { Image } from 'react-datocms';
import Layout from '../../components/Layout/Layout';
import { getActivities } from '../../lib/dato';
import { ActivityRecord } from '../../types/dato.types';

interface Props {
  activities: ActivityRecord[];
}

export default function ActivitiesPage({ activities }: Props) {
  return (
    <Layout title="Activiteiten">
      <div className="gridContainer">
        <div className="grid">
          {activities
            .sort((a, b) => (a.title > b.title ? 1 : -1))
            .map(activity => (
              <div key={activity.title} className="gridInnerContainer">
                <a href={`/activiteiten/${activity.slug}`}>
                  {activity.image ? <Image data={activity.image.responsiveImage} /> : null}
                  <div className="overlay" />
                  <p className="title">{activity.title.toLowerCase()}</p>
                </a>
              </div>
            ))}
        </div>
      </div>
    </Layout>
  );
}

export async function getStaticProps() {
  const activities = await getActivities();
  return {
    props: { activities },
  };
}
